import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        {...props}
    >
        <g clipPath='url(#clip0_6609_5615)'>
            <rect x='4' y='2' width='16' height='20' rx='2' fill='currentColor' />
            <circle cx='19' cy='19' r='5.5' fill='currentColor' stroke='white' />
            <rect x='7' y='5' width='10' height='2' rx='1' fill='white' />
            <rect x='7' y='9' width='6' height='2' rx='1' fill='white' />
            <path
                d='M17.2857 19.8182L20.1429 22L23 19.8182H21.2857V18.1596C21.2857 17.8159 21.2024 17.4773 21.0429 17.1729C20.8296 16.7656 20.49 16.4384 20.0751 16.2404L20.0339 16.2207C19.7295 16.0754 19.3963 16 19.0589 16H18.7143C18.15 16 17.5928 16.1261 17.0836 16.3692L16.7143 16.5455L15 17.6364L16.314 17.2183C16.5793 17.1339 16.856 17.0909 17.1344 17.0909C17.5983 17.0909 18.0444 17.2696 18.38 17.59L18.4098 17.6184C18.7867 17.9782 19 18.4767 19 18.9978V19.8182H17.2857Z'
                fill='white'
            />
        </g>
        <defs>
            <clipPath id='clip0_6609_5615'>
                <rect width='24' height='24' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

export const DownloadReportIcon = styled(Icon)({});
